import { Box, Icon } from '../../widgets'
import { ButtonWrapper } from './'
import { forwardRef } from 'react'

export const IconButton = forwardRef(function IconButton({ icon, size = 32, ...props }, ref) {
  return (
    <ButtonWrapper width={100} ref={ref} {...props}>
      <Box
        gap={8}
        fullWidth
        alignItems="center"
        justifyContent="center"
      >
        <Icon
          icon={icon}
          fill={undefined}
          size={size}
        />
      </Box>
    </ButtonWrapper>
  )
})